export var SendYourDataTestSubject;
(function (SendYourDataTestSubject) {
    SendYourDataTestSubject["CollectionPage"] = "send-your-data-page";
    SendYourDataTestSubject["ShippingProductsTabs"] = "shipping-products";
    SendYourDataTestSubject["ContentGrid"] = "content-grid";
    SendYourDataTestSubject["SearchShippers"] = "search-shippers";
    SendYourDataTestSubject["MarkdownContent"] = "markdown-content";
    SendYourDataTestSubject["ContentCard"] = "content-card";
    SendYourDataTestSubject["InstallGrafanaDashboards"] = "install-grafana-dashboards";
    SendYourDataTestSubject["InfoCard"] = "info-card";
    SendYourDataTestSubject["InfoCardTracingToken"] = "info-card-tracing-token";
    SendYourDataTestSubject["InfoCardAdditionalToken"] = "info-card-additional-token";
    SendYourDataTestSubject["AccountSelect"] = "account-select";
    SendYourDataTestSubject["GuidedTours"] = "guided-tours";
    SendYourDataTestSubject["NeedHelp"] = "need-help";
    SendYourDataTestSubject["SeePlans"] = "see-plans";
    SendYourDataTestSubject["Logout"] = "logout";
    SendYourDataTestSubject["StartCollecting"] = "start-collecting";
    SendYourDataTestSubject["AddBucketButton"] = "add-bucket-button";
    SendYourDataTestSubject["SaveBucketButton"] = "save-bucket-button";
    SendYourDataTestSubject["FilebeatSelector"] = "filebeat-conf-wiz";
})(SendYourDataTestSubject || (SendYourDataTestSubject = {}));
export var AwsS3BucketSubject;
(function (AwsS3BucketSubject) {
    AwsS3BucketSubject["DeleteBucketButton"] = "aws-bucket-delete-button";
    AwsS3BucketSubject["BucketSettingsCard"] = "aws-bucket-settings-card";
    AwsS3BucketSubject["ChooseSecretAccessTypeButton"] = "aws-bucket-choose-secret-type";
    AwsS3BucketSubject["ChooseIAMRoleTypeButton"] = "aws-bucket-choose-iam-type";
    AwsS3BucketSubject["BucketNameInput"] = "aws-bucket-name-input";
    AwsS3BucketSubject["BucketPrefixInput"] = "aws-bucket-prefix-input";
    AwsS3BucketSubject["BucketArnInput"] = "aws-bucket-arn-input";
    AwsS3BucketSubject["BucketRegionSelect"] = "aws-bucket-region-select";
    AwsS3BucketSubject["BucketSourcePathCheckbox"] = "aws-bucket-include-source-path";
    AwsS3BucketSubject["BucketActiveToggle"] = "aws-bucket-is-active-toggle";
    AwsS3BucketSubject["DeleteBucketModal"] = "aws-delete-bucket-modal";
})(AwsS3BucketSubject || (AwsS3BucketSubject = {}));
//# sourceMappingURL=send-your-data.enum.js.map